export default function rgbToHex(r: number, g: number, b: number, in15BitMode = false) {
    return `#${[r, g, b]
        .map((x) => {
            const value = in15BitMode ? Math.round((x / 32768) * 255) : x;
            const clamped = Math.max(0, Math.min(255, value));
            return clamped.toString(16).padStart(2, "0");
        })
        .join("")}`;
}
